import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Records panel art: a log of past runner days. Four rows of date pill,
 * ticker pill, one value bar and a slim green or red percent badge, under a
 * header row, laid out like the Scanner card.
 */
const ROWS: [number, number, boolean][] = [
  [28, 56, true],
  [42, 44, false],
  [56, 62, true],
  [70, 50, false],
]

export function RecordsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* Column headers. */}
      <rect x={12} y={12} width={18} height={5} rx={2} fill="hsl(var(--foreground) / 0.25)" />
      <rect x={35} y={12} width={16} height={5} rx={2} fill="hsl(var(--foreground) / 0.25)" />
      <rect x={57} y={12} width={40} height={5} rx={2} fill="hsl(var(--foreground) / 0.25)" />
      <rect x={124} y={12} width={24} height={5} rx={2} fill="hsl(var(--foreground) / 0.25)" />
      <path
        d="M12 22 H148"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      {ROWS.map(([y, barWidth, rising]) => (
        <g key={y}>
          {/* Date, then ticker. */}
          <rect x={12} y={y} width={18} height={8} rx={3} fill="hsl(var(--foreground) / 0.14)" />
          <rect x={35} y={y} width={16} height={8} rx={3} fill="hsl(var(--foreground) / 0.24)" />
          <rect
            x={57}
            y={y + 2}
            width={barWidth}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
          <rect
            x={124}
            y={y + 1}
            width={24}
            height={6}
            rx={3}
            fill={rising ? 'hsl(var(--positive) / 0.35)' : 'hsl(var(--negative) / 0.35)'}
          />
        </g>
      ))}
    </svg>
  )
}
